/*!
 * PECTY Interactions Engine v2.2
 * Fix: menú móvil — smooth scroll no intercepta nav del tema
 * Fix: cursor custom eliminado (desktop)
 */
(function () {
  'use strict';

  var CFG = { tiltMax: 9, pawCount: 7 };
  var clamp = function(v, lo, hi) { return Math.min(Math.max(v, lo), hi); };

  /* ─ 1. Page entrance ─────────────────────────────────────── */
  document.body.classList.add('pecty-entering');
  window.addEventListener('load', function () {
    requestAnimationFrame(function () {
      document.body.classList.remove('pecty-entering');
      document.body.classList.add('pecty-entered');
    });
  });

  /* ─ 2. Scroll reveal ──────────────────────────────────── */
  function initReveal() {
    if (!window.IntersectionObserver) return;
    var map = [
      { sel: '.pecty-s-head',       cls: 'fade-up', stagger: false },
      { sel: '.pecty-trust-col',    cls: 'fade-up', stagger: true  },
      { sel: '.pecty-product-card', cls: 'fade-up', stagger: true  },
      { sel: '.pecty-cat',          cls: 'zoom-in', stagger: true  },
      { sel: '.pecty-wc',           cls: 'fade-up', stagger: true  },
      { sel: '.pecty-testi',        cls: 'fade-up', stagger: true  },
      { sel: '.pecty-cta-box',      cls: 'fade-up', stagger: false },
      { sel: '.pecty-impact-badge', cls: 'zoom-in', stagger: false },
      { sel: '.pecty-cta-tag',      cls: 'zoom-in', stagger: false },
      { sel: '.pecty-s-tag',        cls: 'zoom-in', stagger: false },
    ];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    map.forEach(function (item) {
      document.querySelectorAll(item.sel).forEach(function (el, i) {
        el.classList.add('pecty-anim', item.cls);
        if (item.stagger) el.dataset.delay = Math.min(i + 1, 8);
        io.observe(el);
      });
    });
    var impactWrap = document.querySelector('.pecty-impact-wrap');
    if (impactWrap) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('anim-visible'); io2.unobserve(e.target); }
        });
      }, { threshold: 0.3 });
      io2.observe(impactWrap);
    }
  }

  /* ─ 3. 3D card tilt ────────────────────────────────── */
  function initTilt() {
    if ('ontouchstart' in window) return;
    document.querySelectorAll('.pecty-product-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r  = card.getBoundingClientRect();
        var rx = clamp(-(e.clientY - r.top  - r.height / 2) / (r.height / 2) * CFG.tiltMax, -CFG.tiltMax, CFG.tiltMax);
        var ry = clamp( (e.clientX - r.left - r.width  / 2) / (r.width  / 2) * CFG.tiltMax, -CFG.tiltMax, CFG.tiltMax);
        card.style.transform  = 'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateY(-5px)';
        card.style.boxShadow  = '0 ' + (16 + Math.abs(ry)) + 'px ' + (32 + Math.abs(rx)) + 'px rgba(62,39,35,0.15)';
        card.style.transition = 'box-shadow 0.1s';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform  = '';
        card.style.boxShadow  = '';
        card.style.transition = 'transform 0.5s cubic-bezier(0.22,1,0.36,1), box-shadow 0.5s ease';
      });
    });
  }

  /* ─ 4. Ripple on buttons ─────────────────────────────────── */
  function initRipple() {
    document.querySelectorAll('.pecty-btn-cta1,.pecty-btn-cta2,.pecty-product-btn,.pecty-sticky-btn').forEach(function (btn) {
      btn.classList.add('pecty-ripple');
      btn.addEventListener('click', function (e) {
        var r  = btn.getBoundingClientRect();
        var sz = Math.max(r.width, r.height) * 2;
        var w  = document.createElement('span');
        w.className = 'pecty-ripple-wave';
        w.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + (e.clientX - r.left - sz / 2) + 'px;top:' + (e.clientY - r.top - sz / 2) + 'px';
        btn.appendChild(w);
        w.addEventListener('animationend', function () { w.remove(); });
      });
    });
  }

  /* ─ 5. Floating paw particles ───────────────────────────────── */
  function initPaws() {
    if (window.innerWidth < 768) return;
    if (!document.querySelector('.pecty-trust')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pecty-pawticles';
    document.body.appendChild(wrap);
    for (var i = 0; i < CFG.pawCount; i++) {
      var el = document.createElement('span');
      el.className   = 'pecty-paw';
      el.textContent = '🐾';
      var dur = 20 + Math.random() * 18;
      el.style.cssText = 'left:' + (5 + Math.random() * 90) + '%;font-size:' + (12 + Math.random() * 14) + 'px;animation-duration:' + dur + 's;animation-delay:' + (-Math.random() * dur) + 's';
      wrap.appendChild(el);
    }
  }

  /* ─ 6. Magnetic CTA buttons ───────────────────────────────── */
  function initMagnetic() {
    if ('ontouchstart' in window) return;
    document.querySelectorAll('.pecty-btn-cta1,.pecty-btn-cta2').forEach(function (btn) {
      btn.classList.add('pecty-magnetic');
      btn.addEventListener('mousemove', function (e) {
        var r  = btn.getBoundingClientRect();
        var dx = (e.clientX - r.left - r.width  / 2) * 0.24;
        var dy = (e.clientY - r.top  - r.height / 2) * 0.24;
        btn.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ─ 7. Ticker pause on hover ───────────────────────────────── */
  function initTicker() {
    var t = document.querySelector('.pecty-ticker-inner');
    if (!t) return;
    t.addEventListener('mouseenter', function () { t.style.animationPlayState = 'paused'; });
    t.addEventListener('mouseleave', function () { t.style.animationPlayState = 'running'; });
  }

  /* ─ 8. Category emoji wiggle ───────────────────────────────── */
  function initCatWiggle() {
    document.querySelectorAll('.pecty-cat').forEach(function (cat) {
      var icon = cat.querySelector('.pecty-cat-e');
      if (!icon) return;
      cat.addEventListener('mouseenter', function () {
        icon.style.animation = 'none';
        void icon.offsetWidth;
        icon.style.animation = '';
      });
    });
  }

  /* ─ 9. Smooth scroll for anchors ───────────────────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      /* FIX CRÍTICO: saltar links dentro del header/nav del tema
         para no interferir con el menú móvil de Horizon */
      if (a.closest('#header-group, header, nav, details')) return;
      a.addEventListener('click', function (e) {
        var target = document.querySelector(href);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  /* ─ Bootstrap ────────────────────────────────────────────────────── */
  function boot() {
    initReveal();
    initTilt();
    initRipple();
    initPaws();
    initMagnetic();
    initTicker();
    initCatWiggle();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
